import React, { createContext, useContext, useState, useCallback } from 'react';
import JoinModal from '../components/JoinModal';

const JoinContext = createContext({ openJoin: () => {} });

export function JoinProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const openJoin = useCallback(() => setIsOpen(true), []);
  const closeJoin = useCallback(() => setIsOpen(false), []);

  return (
    <JoinContext.Provider value={{ openJoin }}>
      {children}
      <JoinModal isOpen={isOpen} onClose={closeJoin} />
    </JoinContext.Provider>
  );
}

export function useJoin() {
  return useContext(JoinContext);
}
